import { createIcon } from '../createIcon';

export const PficonTemplateIconConfig = {
  name: 'PficonTemplateIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M994.1,0 L29.2,0 C13.0801397,0.0165360297 0.0165360297,13.0801397 0,29.2 L0,996 C0,1012.7 13.6,1024 30.3,1024 L994.7,1024 C1010.9,1024 1024,1013.2 1024,997 L1024,29.9 C1023.98897,13.3912576 1010.60874,0.0110315723 994.1,0 Z M960,960 L64,960 L64,64 L960,64 L960,960 Z M384,448 L576,448 L576,384 L384,384 L384,448 Z M448,256 L640,256 L640,192 L448,192 L448,256 Z M832,448 L640,448 L640,384 L768,384 L768,256 L704,256 L704,192 L832,192 L832,448 Z M192,192 L384,192 L384,256 L256,256 L256,384 L320,384 L320,448 L192,448 L192,192 Z M384,832 L576,832 L576,768 L384,768 L384,832 Z M448,640 L640,640 L640,576 L448,576 L448,640 Z M832,832 L640,832 L640,768 L768,768 L768,640 L704,640 L704,576 L832,576 L832,832 Z M192,576 L384,576 L384,640 L256,640 L256,768 L320,768 L320,832 L192,832 L192,576 Z',
  yOffset: 0,
  xOffset: 0,
};

export const PficonTemplateIcon = createIcon(PficonTemplateIconConfig);

export default PficonTemplateIcon;